<template>
  <slot></slot>
  <button ref="submitBtn" class="hidden" type="submit" name="save" value="Add user">{{$t('Add user')}}</button>
</template>

<script>

export default {
  computed: {
    selectedUser() {
      return this.$formValues["frm-quickAddUserForm-quickAddUserForm-user"]
    },
  },
  watch: {
    selectedUser(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.submitBtn.click();
        });
      }
    }
  }
}
</script>